import createReactClass from 'create-react-class';

// Import Libraries
import React from 'react';
import classNames from 'classnames';

// Import JS Modules
import { WithViewportSize } from '../_utils/hoc/with-viewport-size';
import { builderDispatch, WebUI } from '../_utils/ui';
import Failures from './failures';
import FocusTrap from 'focus-trap-react';
import getImageSources from './image-sources';
import LoaderBase from './loader-mixins/loader-base';
import LoaderFooter from './loader-footer';
import LoaderNav from './loader-nav';
import UploadErrors from './utils/upload-errors';
import LoaderAdditionalOptions from './additional-options';
import sendToGoogleAnalytics from '../_libs/analytics/builder-send-to-google-analytics';
import ImageUploadFileValidator from '../_utils/image-upload-file-validator';
import LoaderSizeMixin from './loader-mixins/loader-size-mixin';


const Loader = createReactClass({
  mixins: [LoaderBase, LoaderSizeMixin],
  getInitialState() {
    const windowSize = this.getWindowSize();

    return Object.assign(windowSize, {
      excludeServices: [],
      focus: false,
      hideMenu: false,
      loading: false,
      showUploadErrorsModal: false,
      source: 0,
      target_album: null,
      uploadErrors: [],
      fileUploadValidator: new ImageUploadFileValidator(),
    });
  },

  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    clearTimeout(this._resizeTimeout);
  },

  render() {
    if (!this.state.upload_url) {
      return (
        <div
          aria-hidden="true"
          className="modal fade image-loader"
          role="dialog">
          <div className="modal-dialog modal-xl" role="document" />
        </div>
      );
    }

    const {
      viewport: { isMobile },
    } = this.props;
    const imageSources = getImageSources();
    const activeImageSources = imageSources.filter(source => !this.state.excludeServices.includes(source.service))
    const {
      modal: { width: modalWidth, height: modalHeight },
    } = this.loaderDimensions();
    let $failures, $uploadErrorsModal;

    const $sources = activeImageSources.map((imageSource, i) => {
      const sourceComponentProps = {
        callToActionButtonText: this.state.callToActionButtonText,
        height: this.state.windowHeight,
        isActive: this.state.source === i,
        isMobile,
        key: i,
        onFilesSelected: this.handleFilesSelected,
        onHideMenu: this.handleHideMenu,
        onTargetAlbumSelected: this.handleTargetAlbumSelected,
        onUploaded: this.handleFileUploaded,
        onUploadError: this.handleFileUploadError,
        optimiseUploadFiles: this.state.optimiseUploadFiles,
        ref: imageSource.service,
        service: imageSource.service,
        targetAlbum: this.state.target_album,
        title: imageSource.title,
        fileValidator: this.state.fileUploadValidator,
      };
      return <imageSource.component {...sourceComponentProps} />;
    });

    if (this.state.showFailures) {
      $failures = (
        <Failures
          numberOfFailures={this.number_of_errors}
          shouldRetry
          onIgnore={this.handleAbort}
          onRetry={this.handleAddImages}
          errorMessage={this.errorMessage}
        />
      );
    }

    if (this.state.showUploadErrorsModal) {
      $uploadErrorsModal = (
        <UploadErrors
          errors={this.state.uploadErrors}
          isOpen={this.state.showUploadErrorsModal}
          onClose={this.toggleUploadErrorsModal}
          onRemoveAllClick={this.removeAllUploadErrorsClick}
        />
      );
    }

    return (
      <div
        aria-hidden="true"
        className="modal fade image-loader"
        id="uploader"
        role="dialog"
        aria-label="Upload photos"
        style={{ height: modalHeight, width: modalWidth, margin: 'auto' }}>
        <div className="modal-dialog modal-xl p-0" role="document">
          <FocusTrap active={this.state.focus}>
            <div className={classNames('modal-content', { mini: $failures })}>
              <div
                className={classNames('modal-header flex-column rounded-0', {
                  'd-none': this.state.hideMenu,
                })}>
                <LoaderNav
                  activeSource={this.state.source}
                  imgSources={activeImageSources}
                  isMobile={this.props.viewport.isMobile}
                  onSourceSelect={this.handleSourceSelect}
                />
              </div>
              <div className="modal-body justify-content-between">
                {!$failures && $sources}
                {$failures}
                {$uploadErrorsModal}
              </div>
              <LoaderFooter
                brokenPreviews={this.state.uploadErrors}
                files={this.previews()}
                onAddImages={this.onAddImagesClick}
                onCancelClick={this.handleCancelClick}
                onErrorIconClick={this.toggleUploadErrorsModal}
                onRemoveThumbnail={this.handleRemovePreview}
                onImagePreviewError={this.handleImagePreviewError}
              />
            </div>
          </FocusTrap>
        </div>
      </div>
    );
  },

  onAddImagesClick() {
    this.handleAddImages();
  },

  handleHideMenu(hideMenu) {
    this.setState({ hideMenu });
  },

  handleCancelClick() {
    this.handleAbort();

    this.triggerFeatureTracking('Cancel');
  },

  triggerFeatureTracking(type) {
    sendToGoogleAnalytics('Loader-nav', `${type}`);
  },

  handleAddImages() {
    this.triggerFeatureTracking('Add');
    const { upload_url, target_album, uploadSource } = this.state;

    this.filterBrokenImages();

    this.performUpload(upload_url, {
      album: target_album?.id || target_album?.title,
      uploadSource,
    });
    this.close();
    builderDispatch.delayedDispatch({
      type: WebUI.UPLOAD_ALL_PHOTOS_REMOVED_FROM_TRAY,
    });
  },
});

export default WithViewportSize(Loader);
